// extracted by mini-css-extract-plugin
module.exports = {"nav-space":"Main_nav-space__1CYXV"};